import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

const PREFIX_LENGTH = 11

const Prefix = styled.span`
  color: #94a3b8;
`

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const SensorSerialNumber = ({ cell }: Props) => {
  const value = String(cell.getValue().value ?? "")

  if (!cell.row.parentId) return <>{value}</>

  return (
    <>
      <Prefix>{value.slice(0, PREFIX_LENGTH)}</Prefix>
      {value.slice(PREFIX_LENGTH)}
    </>
  )
}
